import { useState, useCallback, useEffect } from 'react'

type Props = {
  isLoaded?: boolean
  element: React.RefObject<HTMLElement>
}

const useAutoFocus = ({ isLoaded = true, element }: Props) => {
  const [autoFocusExecuted, setAutoFocusExecuted] = useState(false)

  const removeTabindex = useCallback((e) => {
    if (e.key === 'Tab') {
      element?.current?.removeAttribute('tabindex')
    }
  }, [element])

  useEffect(() => {
    if (!element?.current || !isLoaded || autoFocusExecuted) {
      return
    }

    element.current.onkeydown = removeTabindex
    element.current.setAttribute('tabindex', '0')
    element.current.style.outline = 'none'
    element.current.focus()
    setAutoFocusExecuted(true)
  }, [isLoaded, autoFocusExecuted, setAutoFocusExecuted, element, removeTabindex])
}

export default useAutoFocus
